import { styled, Switch, Typography } from '@mui/material';
import { MouseEventHandler } from 'react';
import { device } from 'src/constants/mediaQueries';

interface ToggleProps {
  checked: boolean;
  label?: string;
  states?: Record<'checkedState' | 'unCheckedState', string>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
  id: string;
}

function ToggleLabel({ checked, states }: Pick<ToggleProps, 'checked' | 'states'>) {
  /* istanbul ignore next */
  if (!states) {
    return null;
  }
  return checked ? <>{states.checkedState}</> : <>{states.unCheckedState}</>;
}

export default function Toggle({ checked, label, states, onClick, loading, id }: Readonly<ToggleProps>) {
  return (
    <div>
      <label htmlFor={id}>
        <FieldLabel>{label}</FieldLabel>
      </label>
      <Switch id={id} checked={checked} onClick={onClick} color="secondary" disabled={loading} />
      <ToggleLabel checked={checked} states={states} />
    </div>
  );
}

const FieldLabel = styled(Typography)`
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.25rem;

  @media ${device.mobileOrTablet} {
    width: 350px;
  }
  @media ${device.smallLaptop} {
    width: 350px;
    margin-bottom: 1rem;
  }
`;
